import { render, staticRenderFns } from "./DisbursementStatusTable.vue?vue&type=template&id=8f47893a"
import script from "./DisbursementStatusTable.vue?vue&type=script&lang=js"
export * from "./DisbursementStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports